var map = {
	"./ask.svg": "688a",
	"./chart.svg": "20e7",
	"./components.svg": "7a81",
	"./control.svg": "d2f1",
	"./editor.svg": "54cc",
	"./flash.svg": "7d24",
	"./home.svg": "0331",
	"./message.svg": "15e8",
	"./monitoring.svg": "f386",
	"./other.svg": "7b2c",
	"./page.svg": "452c",
	"./pagedetails.svg": "6394",
	"./pageform.svg": "688a4",
	"./pagelist.svg": "47fb",
	"./s-fold.svg": "ba71",
	"./s-unfold.svg": "3728",
	"./set.svg": "6274",
	"./tree.svg": "0e8f",
	"./weichat.svg": "66ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";